import React, { FC } from 'react'
import { VIEW_TYPE } from '../../store/managePost/newTypes'
import Desktop from '../UI/Icons/Desktop'
import Mobile from '../UI/Icons/Mobile'
import GridIcon from '../UI/Icons/Grid'
import CustomPopup from '../UI/Popup'

import './ChangeView.scss'

interface ChangeViewProps {
  changeView: (view: VIEW_TYPE) => void
  view: VIEW_TYPE
  isEnableGridView?: boolean
}

const ChangeView: FC<ChangeViewProps> = ({ changeView, view, isEnableGridView }) => {
  return (
    <div className='change-view'>
      <CustomPopup
        updateTrigger={view}
        className='post-creation-popup'
        on='hover'
        position='top center'
        offsetX={10}
        offsetY={10}
        trigger={() => (
          <button
            className={`${view === VIEW_TYPE.TYPE_DESKTOP && 'active'}`}
            onClick={() => changeView(VIEW_TYPE.TYPE_DESKTOP)}
          >
            <Desktop />
          </button>
        )}
      >
        Desktop
      </CustomPopup>

      <CustomPopup
        updateTrigger={view}
        position='top center'
        on='hover'
        className='post-creation-popup'
        offsetX={10}
        offsetY={10}
        trigger={() => (
          <button
            className={`${view === VIEW_TYPE.TYPE_MOBILE && 'active'}`}
            onClick={() => changeView(VIEW_TYPE.TYPE_MOBILE)}
          >
            <Mobile />
          </button>
        )}
      >
        Mobile
      </CustomPopup>

      {isEnableGridView && (
        <CustomPopup
          updateTrigger={view}
          position='top center'
          on='hover'
          className='post-creation-popup'
          offsetX={10}
          offsetY={10}
          trigger={() => (
            <button
              className={`${view === VIEW_TYPE.TYPE_GRID && 'active'} grid-icon`}
              onClick={() => changeView(VIEW_TYPE.TYPE_GRID)}
            >
              <GridIcon />
            </button>
          )}
        >
          Grid
        </CustomPopup>
      )}
    </div>
  )
}

export default ChangeView
